export async function shareOrDownloadFile({
    blob,
    filename,
    title = "Tattune Export",
    text = "Created with Tattune",
  }) {
    if (!blob) return false;
  
    const file = new File([blob], filename, {
      type: blob.type || "application/octet-stream",
    });
  
    const canNativeShare =
      typeof navigator !== "undefined" &&
      typeof navigator.share === "function";
  
    if (canNativeShare) {
      try {
        const canShareFiles =
          !navigator.canShare || navigator.canShare({ files: [file] });
  
        console.log("[share] trying native share", {
          filename,
          type: file.type,
          size: file.size,
          canShareFiles,
        });
  
        if (canShareFiles) {
          await navigator.share({
            title,
            text,
            files: [file],
          });
          return true;
        }
      } catch (err) {
        console.warn("[share] native share failed, falling back to download", err);
      }
    }
  
    const url = URL.createObjectURL(blob);
    try {
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.click();
      return true;
    } finally {
      setTimeout(() => {
        try {
          URL.revokeObjectURL(url);
        } catch {}
      }, 10000);
    }
  }